/* WD Landing Page — Shared Animations v3 (~3KB)
 * Scroll reveals, word splitting, tile mouse tracking, FAQ accordion, reduced motion
 */
(function(){
  if(window.__wdInit) return;
  window.__wdInit=true;
  var R=window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  // Inject core CSS
  var s=document.createElement('style');
  s.textContent=[
    '.wd-reveal{opacity:0;transform:translateY(30px);transition:opacity .8s ease,transform .8s ease}',
    '.wd-reveal.wd-visible{opacity:1;transform:translateY(0)}',
    '.wd-delay-1{transition-delay:.15s}.wd-delay-2{transition-delay:.3s}',
    '.wd-delay-3{transition-delay:.45s}.wd-delay-4{transition-delay:.6s}',
    '.wd-delay-5{transition-delay:.75s}',
    // Word reveal
    '.wd-text-reveal .wd-word{display:inline-block;opacity:0;filter:blur(6px);transform:translateY(12px);transition:opacity .5s ease,filter .5s ease,transform .5s ease;transition-delay:calc(var(--i,0)*.06s)}',
    '.wd-text-reveal.wd-visible .wd-word{opacity:1;filter:blur(0);transform:translateY(0)}',
    // Accent pop on em inside word reveal
    '.wd-text-reveal.wd-visible .wd-word em{animation:wd-accentPop .4s ease forwards;animation-delay:calc(var(--i,0)*.06s + .3s)}',
    '@keyframes wd-accentPop{0%{transform:scale(1)}50%{transform:scale(1.06)}100%{transform:scale(1)}}',
    // Animated border property
    '@property --wd-ba{syntax:"<angle>";initial-value:0deg;inherits:false}',
    '@keyframes wd-bspin{to{--wd-ba:360deg}}'
  ].join('');
  if(R) s.textContent+='.wd-reveal{opacity:1!important;transform:none!important;transition:none!important}.wd-text-reveal .wd-word{opacity:1!important;filter:none!important;transform:none!important;transition:none!important}';
  document.head.appendChild(s);

  // IntersectionObserver for reveals
  function observeReveals(){
    document.querySelectorAll('.wd-reveal:not(.wd-visible)').forEach(function(el){obs.observe(el)});
  }
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('wd-visible');obs.unobserve(e.target)}
    });
  },{threshold:0.12});
  observeReveals();
  new MutationObserver(observeReveals).observe(document.body,{childList:true,subtree:true});

  // Word splitter for text reveal (defer to ensure DOM is ready)
  function splitAllWords(){
    document.querySelectorAll('.wd-text-reveal:not([data-wd-split])').forEach(function(el){
      el.setAttribute('data-wd-split','1');
      var idx=0;
      var frag=document.createDocumentFragment();
      Array.prototype.slice.call(el.childNodes).forEach(function(node){
        if(node.nodeType===3){
          node.textContent.split(/(\s+)/).forEach(function(p){
            if(/\S/.test(p)){
              var sp=document.createElement('span');
              sp.className='wd-word';
              sp.style.setProperty('--i',idx++);
              sp.textContent=p;
              frag.appendChild(sp);
            } else {
              frag.appendChild(document.createTextNode(p));
            }
          });
        } else if(node.nodeType===1){
          var clone=node.cloneNode(false);
          (node.textContent||'').split(/(\s+)/).forEach(function(p){
            if(/\S/.test(p)){
              var sp=document.createElement('span');
              sp.className='wd-word';
              sp.style.setProperty('--i',idx++);
              sp.textContent=p;
              clone.appendChild(sp);
            } else {
              clone.appendChild(document.createTextNode(p));
            }
          });
          frag.appendChild(clone);
        }
      });
      el.innerHTML='';
      el.appendChild(frag);
    });
  }

  if(!R){
    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',splitAllWords);
    } else {
      splitAllWords();
    }
    // Also re-run on mutation for dynamic content
    new MutationObserver(splitAllWords).observe(document.body,{childList:true,subtree:true});
  }

  // Mouse tracking for premium tiles (desktop only)
  if(!R && window.matchMedia('(hover:hover)').matches){
    document.addEventListener('mousemove',function(e){
      var t=e.target.closest('.wd-tile-track');
      if(!t) return;
      var r=t.getBoundingClientRect();
      t.style.setProperty('--mx',((e.clientX-r.left)/r.width*100).toFixed(1)+'%');
      t.style.setProperty('--my',((e.clientY-r.top)/r.height*100).toFixed(1)+'%');
    },{passive:true});
  }

  // FAQ accordion
  document.addEventListener('click',function(e){
    var h=e.target.closest('.wd-faq__header');
    if(!h) return;
    var item=h.parentElement;
    var isOpen=item.classList.contains('wd-faq--open');
    item.parentElement.querySelectorAll('.wd-faq--open').forEach(function(el){el.classList.remove('wd-faq--open')});
    if(!isOpen) item.classList.add('wd-faq--open');
  });

  // Mockup auto-scroll on visibility
  if(!R){
    var mObs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add('wd-mockup--scrolling');mObs.unobserve(e.target)}
      });
    },{threshold:0.3});
    document.querySelectorAll('.wd-mockup__inner').forEach(function(el){mObs.observe(el)});
    new MutationObserver(function(){
      document.querySelectorAll('.wd-mockup__inner:not(.wd-mockup--scrolling)').forEach(function(el){mObs.observe(el)});
    }).observe(document.body,{childList:true,subtree:true});
  }
})();
